<template>
  <div class="actions is-centered">
    <AppRadialMenu
      :size="36"
      :item-size="48"
      :radius="80"
      :angle-restriction="180"
      :rotate="270"
    >
      <AppRadialMenuItem
        class="tooltip is-tooltip-primary has-background-primary has-text-white"
        data-tooltip="Detalle de auto factura"
      >
        <RouterLink
          class="action-option"
          :to="{ name: 'InvoiceDetail', params: { uuid: id } }"
        >
          <BIcon
            icon="eye"
            class="action-option-icon"
          />
        </RouterLink>
      </AppRadialMenuItem>
      <AppRadialMenuItem
        class="tooltip is-tooltip-success has-background-success has-text-white"
        data-tooltip="Regenerar PDF"
      >
        <a
          class="action-option"
          @click="regeneratePdf('pdf', invoice)"
        >
          <BIcon
            icon="autorenew"
            class="action-option-icon"
          />
          <span class="close-label">
            pdf
          </span>
        </a>
      </AppRadialMenuItem>
    </AppRadialMenu>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'HistoryStampedActions',
  components: {
    AppRadialMenu: () => import(/* webpackChunkName: "app-radial-menu" */ '../../AppRadialMenu.vue'),
    AppRadialMenuItem: () => import(/* webpackChunkName: "app-radial-menu-item" */ '../../AppRadialMenuItem.vue'),
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    invoice: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState({
      company: state => state.company.id,
    }),
  },
};
</script>

<style scoped>
.box.is-centered.confirmation {
  max-width: 400px;
}
</style>
